module.exports = __webpack_public_path__ + "static/banco-de-leite-a05831654936e2aca5baa2d5f63a48b6.jpg";